var render = function render(_c,_vm){return _c('div',[_c('div',[_vm._v(_vm._s(_vm.props.name))]),_vm._v(" "),_c('div',{staticClass:"has-text-grey-light"},[_vm._v(_vm._s(_vm.props.sector_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }